import { render, staticRenderFns } from "./RealTimeCount.vue?vue&type=template&id=629144fe"
import script from "./RealTimeCount.vue?vue&type=script&lang=js"
export * from "./RealTimeCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports